import { isFormValid, setError } from '../../../library/Core/SmartFunctions';
import { ControlOnChangeArguments, DispatchEvent, State } from '../../../library/Core/SmartTypes';
import JobPostingService from '../../../services/job-posting.service';

export const onSave = (event: React.SyntheticEvent<HTMLButtonElement>, state: State, dispatch: (dispatchEvent: DispatchEvent) => void) => {
    event.preventDefault();

    let isError = false;
    if(state?.data?.jobPosting?.jobPostVisibleTo != 'STUDENT')
    {
        state?.data?.jobPostingVisibity?.map((v: any,index: number) => {
            if(v.programId && v.passOutYear.length === 0)
            {
                setError(`jobPostingVisibity.${index}.programId`,['"Program Completion Year" is required'],dispatch);
                isError = true;
            }
            else
            {
                setError(`jobPostingVisibity.${index}.programId`,[],dispatch)
            }
        });

        //error for duplicate programs
        const uniqueProgramIds = new Set();
        state?.data?.jobPostingVisibity?.map((v: any, index: number) => {
            if (v.programId !== '' && uniqueProgramIds.has(v.programId)) {
                setError(`jobPostingVisibity.${index}.programId`,['Duplicate programs not allowed.'],dispatch);
                isError = true;
            }
            uniqueProgramIds.add(v.programId);
        });
    }
    else
    {
        state?.data?.jobPostingVisibity?.map((v: any,index: number) => {
            setError(`jobPostingVisibity.${index}.programId`,[],dispatch)
        });
    }

    if (!isFormValid(state, dispatch)) {
        alert('Please correct the form errors!');
        return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(state?.data?.jobPosting?.contactEmail)) {
        setError(`jobPosting.contactEmail`,['Please enter a valid contact email address.'],dispatch);
        isError = true;
    }
    
    if(isError){
        dispatch({ type: 'SHOW_ERRORS' });
        alert('Please correct the form errors!');
        return;
    }

    JobPostingService.saveJobPosting(state.data).then((response) => {
        state.actions['ROUTER_NAVIGATE'](`/job-posting`);
    });
};

export const onMaxExpChange = (props: ControlOnChangeArguments) => {
    console.log(props.value);
    const minExperience = parseInt(props.row['minExperience'], 10);
    const maxExperience = parseInt(props.value, 10);

    if (isNaN(maxExperience)) {
        props.errorMessages.push('Please enter a valid number for maximum experience');
        return;
    }

    if (maxExperience < minExperience) {
        props.errorMessages.push('Maximum experience should be greater than or equal to minimum experience');
        return;
    }
};

export const onChangeTitle = (props: ControlOnChangeArguments) => {
    const value = props.value;

    // Check if the value is a number
    if (!isNaN(value)) {
        props.errorMessages.push('Please enter a valid job title.');
        return;
    }
};

export const onChangeCompanyName = (props: ControlOnChangeArguments) => {
    const value = props.value;

    // Check if the value is a number
    if (!isNaN(value)) {
        props.errorMessages.push('Please enter a valid comppay name.');
        return;
    }
};
